<template>
    <div class="detailedData">
        <sky-radio v-model="radioVal" :options="radioOptions" :border="false" size="small"></sky-radio>

        <filter-panel class="filter-panel" :data="groups" labelWidth="80px" :simple="true" @search="filterChange">
        </filter-panel>

        <!-- 扫描时间 -->
        <div class="time">最近一次扫描时间：{{ argRankAndkeyWordInfo.taskDate }}</div>

        <data-list :table-style="{ name: 'webclient' }" :data="data" :columns="columns" :loading="loading" :page="page"
            :page-size="page.pageSize" @page-size-changed="pageSizeChanged" @page-changed="pageChanged"
            @sort-change="sortChange"></data-list>
    </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import skyRadio from '@/components/iglobalwin/formComponents/sky-radio.vue';
import keywordRanking from '@/backend/services/keywordRanking/keywordRanking.js';
const list = listPageCreate({
    searchConfig: {
        api: api.keywordRanking.keyword,
        method: 'POST',
    },
    setExtension: (self) => {
       let { serviceSiteId } = self
        return {
            PathParam: {
                serviceSiteId
            }
        }
    },
    getQuery(data, that) {
        let { keywords,   } = data;
        let ranking = that.groups.others[1].value
        let landingPageUrl =  that.groups.others[2].value
        let device = that.groups.others[3].value
        let { radioVal } = that;
        if (keywords) data.keywords = [keywords];
        else delete data.keywords;
        if(device) data.device = [device]
		else data.device = ['PC', "MOBILE"]
        if (ranking) data.ranking = ranking;
        else delete data.ranking;
        if (landingPageUrl) data.landingPageUrl = [landingPageUrl];
        else delete data.landingPageUrl;
        if (radioVal) data.geoLocation = [radioVal];
        else delete data.geoLocation;
        console.log(data)
        return data;
    },
});

export default {
    name: 'detailedData',
    components: {
        filterPanel,
        skyRadio,
    },
    props: {
        serviceSiteId: {
            type: String,
            default: ""
        }
    },
    mixins: [list],
    data() {
        let that = this;
        return {
            radioVal: '',
            argRankAndkeyWordInfo: {
                taskDate: '--',
            },
            radioOptions: [
                {
                    label: '不限地区',
                    value: '',
                },
                {
                    label: '澳大利亚',
                    value: 'AU',
                },
                {
                    label: '加拿大',
                    value: 'CA',
                },
                {
                    label: '德国',
                    value: 'DE',
                },
                {
                    label: '西班牙',
                    value: 'ES',
                },
                {
                    label: '法国',
                    value: 'FR',
                },
                {
                    label: '日本',
                    value: 'JP',
                },
                {
                    label: '墨西哥',
                    value: 'MX',
                },
                {
                    label: '美国',
                    value: 'US',
                },
                {
                    label: '英国',
                    value: 'UK',
                },
                {
                    label: '印度',
                    value: 'IN',
                },
            ],
            groups: {
                others: [
                    {
                        tagName: 'sky-input',
                        placeholder: '请输入关键词',
                        col: 4,
                        prop: 'keywords',
                        value: '',
                        clearable: true,
                    },
                    {
                        tagName: 'sky-select',
                        placeholder: '排名',
                        col: 3,
                        prop: 'ranking',
                        value: '',
                        options: [
                            {
                                label: '前5',
                                value: 5,
                            },
                            {
                                label: '前10',
                                value: 10,
                            },
                            {
                                label: '前20',
                                value: 20,
                            },
                            {
                                label: '前50',
                                value: 50,
                            },
                        ],
                    },
                    {
                        tagName: 'sky-input',
                        placeholder: '请输入相关链接',
                        col: 4,
                        prop: 'landingPageUrl',
                        value: '',
                        clearable: true,
                    },
                    {
						tagName: 'sky-select',
						placeholder: ' 设备',
						col: 3,
						prop: 'device',
						value: '',
						options: [
                            {
								label: '全部',
								value: '',
                            },
							{
								label: 'PC',
								value: 'PC',
							},
							{
								label: '移动端',
								value: 'MOBILE',
							},
						],
					},
                ],
            },
            columns: [
                {
                    label: '关键词',
                    bind: 'keywords',
                    align: 'left',
                    type: 'percentage',
                    dataStyle(val) {
                        return val || '-';
                    },
                },
                {
                    label: '国家地区',
                    bind: 'geoLocation',
                    align: 'left',
                    type: 'percentage',
                    dataStyle(val) {
                        return val || '-';
                    },
                },
                {
                    label: '排名',
                    bind: 'ranking',
                    align: 'left',
                    type: 'percentage',
                    sort: 'SERP_RANKING',
                    options: [
                        {
                            label: '由高到低',
                            value: 'asc',
                        },
                        {
                            label: '由低到高',
                            value: 'desc',
                        },
                    ],
                    dataStyle(val) {
                        return val || '-';
                    },
                },
                {
					label: ' 设备',
					bind: 'device',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						let obj = {
							'MOBILE': '移动',
							'PC': 'PC'
						}
						return obj[val] || '-'; 
					},
				},
                {
                    label: '页面链接',
                    bind: 'landingPageUrl',
                    align: 'left',
                    type: 'percentage',
                    width: '300',
                    showOverflowTooltip: true,
                    style: {
                        color: '#3DA1FF',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                    },
                    dataStyle(val) {
                        return val || '-';
                    },
                },
                {
                    label: '快照',
                    type: 'btnClick',
                    align: 'left',
                    style: 'text',
                    bind() {
                        let arr = [
                            {
                                text: '查看',
                                trigger(row) {
                                    that.getPictureInfo(row.taskInstanceResultId);
                                },
                            },
                        ];
                        return arr;
                    },
                },
            ],
        };
    },
    watch: {
        radioVal: {
            handler() {
                this.requestData(this.serviceSiteId);
            },
        },
        serviceSiteId: {
            handler(val) {
                if(val) {
                    this.requestData(val);
                }
            },
            deep: true,
        },
        '$route.query': {
            handler(val) {
                if (val.ranking && val.ranking != 50) {
                    this.groups.others[1].value = val.ranking - 0;
                }
                if (val.landingPageUrl) this.groups.others[2].value = val.landingPageUrl;
                if (val.geoLocation) this.radioVal = val.geoLocation;
                this.requestData(this.serviceSiteId);
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        requestData(serviceSiteId) {
            if(!serviceSiteId) return
            this.query();
            this.getArgTamkKeywordInfo(serviceSiteId);
        },
        // 查看快照
        async getPictureInfo(taskInstanceResultId) {
            let { data } = await keywordRanking.getviewPicture({
                taskInstanceResultId,
            });
            this.$emit('getPictureInfo', data);
        },
        // 获取平均排名和有关键词的排名
        async getArgTamkKeywordInfo(serviceSiteId) {
            let params = {
                device: this.groups.others[3].value,
                serviceSiteId: serviceSiteId
            }
            let { data } = await keywordRanking.getArgRankAndKey(params);
            if(data) {
                this.argRankAndkeyWordInfo = data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.detailedData {
    padding: 0 20px;
    background: #ffffff;
    margin-top: 20px;
    padding-top: 20px;

    ::v-deep  .el-radio-group {
        .el-radio {
            .el-radio__input {
                display: none;
            }

            .el-radio__label {
                padding-left: 5px;
            }
        }
    }

    ::v-deep .filterPanel {
        margin-bottom: 0px;

        .filterMultiple {
            padding: 0 0 10px;
        }
    }

    .time {
        font-size: 15px;
        margin: 10px 0 20px;
    }
}
</style>

    